import {
  init,
  browserTracingIntegration,
  replayIntegration,
  thirdPartyErrorFilterIntegration,
} from "@sentry/remix";
import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";
import { WindowWithENV } from "./types/global";
import { isEasySizeTypeError } from "./monitor.client";

init({
  dsn: "https://9da1adb56c900026eb722b849dc4ef26@o4509158534479872.ingest.us.sentry.io/4509158541688832",
  tracesSampleRate: 1,
  environment: (window as WindowWithENV).ENV?.ENVIRONMENT,
  integrations: [
    browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
    replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
    thirdPartyErrorFilterIntegration({
      // Specify the application keys that you specified in the Sentry bundler plugin
      filterKeys: ["shirtspace-frontend"],
      // Defines how to handle errors that contain third party stack frames.
      // Possible values are:
      // - 'drop-error-if-contains-third-party-frames'
      // - 'drop-error-if-exclusively-contains-third-party-frames'
      // - 'apply-tag-if-contains-third-party-frames'
      // - 'apply-tag-if-exclusively-contains-third-party-frames'
      behaviour: "drop-error-if-exclusively-contains-third-party-frames",
    }),
  ],
  beforeSend: (errorEvent) => {
    if (isEasySizeTypeError(errorEvent)) {
      return null;
    }

    return errorEvent;
  },
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>,
  );
});
